var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    fill: "none",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffce48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "m307.492 139.793-17.541-10.128c-6.307-3.643-8.476-11.719-4.833-18.026l13.719-23.763c3.643-6.307 11.719-8.476 18.025-4.833l6.118 3.527c6.306 3.643 8.475 11.719 4.832 18.026zm-96.614 59.467 54.076-62.162s48.517 31.334 59.636 41.441l62.162 1.517s-1.517 26.785-22.743 26.785h-48.516l-39.42-30.829m8.308 6.486-36.104 43.042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.169 169.042-32.355-1.116-29.312 31.839s-13.14 10.108-28.807-1.01l50.538-61.657h67.721m-80.029 52.423-19.057-14.172m193.088 4.022v27.47m-304.24 138.98h319.907m-153.679-91.916 41.989 24.7v67.216m0-24.764h34.872"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.557 345.821-18.752-23.753v-40.936c0-23.247-16.172-31.839-16.172-31.839l-70.754-50.033-45.484 62.668s-6.065.505-46.496 0c-40.43-.506-40.936 33.355-40.936 33.355s40.431.505 72.775 0c32.345-.506 44.474-14.656 44.474-14.656l53.065-55.087m-129.378 36.387v33.577"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.fbf4389fa3192ba5ce88f49354a9161c.svg";
export { ForwardRef as ReactComponent };